import { render, staticRenderFns } from "./ErrorReq.vue?vue&type=template&id=4aaff521"
import script from "./ErrorReq.vue?vue&type=script&lang=js"
export * from "./ErrorReq.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports